import { MarginMode } from "@cede/types";

/**
 * Display string for a Hyperliquid position's margin mode. `"-"` covers the
 * `MarginMode.UNKNOWN` read-only state that CCXT can return when it cannot
 * classify a position from the venue payload.
 */
export function formatMarginMode(mode: MarginMode | undefined): string {
  switch (mode) {
    case MarginMode.ISOLATED:
      return "Isolated";
    case MarginMode.CROSS:
      return "Cross";
    default:
      return "-";
  }
}
